// extracted by mini-css-extract-plugin
export default {"wrapper":"HudMenu_wrapper__Fa3eE"};